export const Unauthorized = () => {
  return (
    <div className="flex h-screen items-center justify-center text-xl text-red-600">
      Acesso negado: você não tem permissão para acessar esta página.
    </div>
  );
};
